import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { Link, useNavigate } from "react-router-dom";

import "./OffCanvasCard.css";
import { currencySymbol } from "../../../utils/helpers";
import CurrencyFormat from "react-currency-format";
import DynamicTitle from "../../Product/DynamicTitle";

// ---------------------------------------------------------

const OffCartCanvasCard = ({
  item,
  removeItem,
  decreaseQuantity,
  increaseQuantity,
}) => {
  console.log('item', item);
  return (
    <>
      <li
        className="cart-item d-flex align-items-center border-bottom py-3"
        key={item.id + item?.product_variant_id}
      >
        <div className="cart-media">
          <img
            height={100}
            width={100}
            src={
              item?.product_variant?.images[0]?.url ||
              `${process.env.PUBLIC_URL}/images/placeholder-images.png`
            }
            onError={() =>
              `${process.env.PUBLIC_URL}/images/placeholder-images.png`
            }
            alt="product"
          />
          <button className="cart-delete" onClick={() => removeItem(item.id)}>
            <i className="fas fa-trash-alt"></i>
          </button>
        </div>
        <div className="cart-info-group">
          <div className="cart-info">
            <h6>
              <Link
                to={
                  item?.cart_type === "quote"
                    ? `/view-requested-quote/${item?.quote?.id}`
                    : item?.product_variant?.variant_type === "1"
                    ? "/product-detail/" + item?.product?.slug
                    : "/product-detail/" + item?.product_variant?.slug
                }
              >
                <DynamicTitle data={item?.product_variant} />
              </Link>
            </h6>
            <p className="text-muted">
              Price - {currencySymbol()}
              {
                <CurrencyFormat
                  value={item.price}
                  displayType={"text"}
                  thousandSeparator={true}
                  fixedDecimalScale={true}
                  decimalScale={2}
                />
              }
            </p>
            {item?.quote?.quote_number != null && (
              <p className="text-muted">Quote: {item?.quote?.quote_number}</p>
            )}
          </div>
          <div className="cart-action-group d-flex justify-content-between">
            <div className="product-action input-group input-group-sm input-spinner quantity mt-1">
              <button
                disabled={item.cart_type === "quote"}
                onClick={() => decreaseQuantity(item)}
                className="qtyminus minus btn btn_qty"
                type="button"
              >
                <i className="fas fa-minus"></i>
              </button>
              <input
                className="form-control text-center qty"
                name="quantity"
                placeholder=""
                value={item.qty}
                readOnly={true}
              />
              <button
                disabled={item.cart_type === "quote"}
                onClick={() => increaseQuantity(item)}
                className="qtyplus plus btn btn_qty"
                type="button"
              >
                <i className="fas fa-plus"></i>
              </button>
            </div>
            <h6 className="fw-500 text-primary mt-2">
              {currencySymbol()}
              {
                <CurrencyFormat
                  value={item.price * item.qty}
                  displayType={"text"}
                  thousandSeparator={true}
                  fixedDecimalScale={true}
                  decimalScale={2}
                />
              }
            </h6>
          </div>
        </div>
      </li>
    </>
  );
};

export default React.memo(OffCartCanvasCard);
